import { api } from './api';

export const serviceUrl = (url, serviceId = api.SERVICE_ID) => `services/${serviceId}/${url}`;

export const serviceApi = {
  fetchJSON: (url, options, serviceId, bypassErrorCodes = []) =>
    api.fetchJSON(serviceUrl(url, serviceId), options, bypassErrorCodes),
  fetch: (url, options, serviceId, bypassErrorCodes = []) =>
    api.fetch(serviceUrl(url, serviceId), options, bypassErrorCodes),
  fetchJSONFromAPI: (url, options, serviceId, bypassErrorCodes = []) =>
    api.fetchJSONFromAPI(serviceUrl(url, serviceId), options, bypassErrorCodes),
};
